import React from "react";
import { Layout, Menu } from 'antd';
import { SettingFilled } from '@ant-design/icons';
import { Link } from "react-router-dom";

const { SubMenu } = Menu;
const { Sider } = Layout;

const Sidebar = () => {
    return(
        <>
        <Sider className="site-layout-background" width={200}  breakpoint="md" style={{marginTop: "70px"}}
      collapsedWidth="0"
      onBreakpoint={broken => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
      }}>
          <Menu
            mode="inline"
            defaultSelectedKeys={['1']}
            defaultOpenKeys={['sub1']}
            style={{ height: '100%' }}
          >
            <SubMenu key="sub1" icon={<SettingFilled/>} title="Movies">
              <Menu.Item key="1" ><Link to="/data-movies">Data Movies</Link></Menu.Item>
              <Menu.Item key="2"><Link to="/create-data-movies"> Create Data Movies</Link> </Menu.Item>
            </SubMenu>
            <SubMenu key="sub2" icon={<SettingFilled />} title="Games">
              <Menu.Item key="5"><Link to="/data-games">Data Games</Link></Menu.Item>
              <Menu.Item key="6"><Link to="/create-data-games">Create Data Games</Link></Menu.Item>
            </SubMenu>
          </Menu>
        </Sider>
        </>
    )
}

export default Sidebar